import React, { Component } from 'react';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';
import { AccentColor } from 'helpers/AccentColorHelper';

import * as bookings from 'actions/bookingsActions';
import { getTenantTodoList } from 'actions/todoActions';

import AmenityBookingForm from 'components/shared/AmenityBookingForm';

const mapStateToProps = function(state) {
  return {
    isLoading: state.bookings.isLoading,
  };
};

export default localize()(
  withMobileDialog()(
    connect(mapStateToProps, { ...bookings, getTenantTodoList })(
      class TenantAmenityBookingDialog extends Component {
        submitForm = vars => {
          this.props.setToIsLoading();
          this.props.removePreviousSearchResults();
          const original_booking_id = this.props.amenityDetails.booking_id || null;
          this.props.showAvailableAmenityBookings(
            this.props.amenityDetails.id,
            vars.time,
            vars.date,
            vars.requested_booking_length,
            original_booking_id
          );
        };

        cancelAmenityBooking = booking_id => {
          this.props.cancelAmenityBooking(booking_id).then(() => {
            this.props.getTenantTodoList({ show_only: 'AmenityBooking' });
            this.props.toggleBookingDialog();
          });
        };

        render() {
          const amenity = this.props.amenityDetails;

          return (
            <Dialog
              fullScreen={this.props.fullScreen}
              open={this.props.showBooking}
              onClose={this.props.toggleBookingDialog}
              aria-labelledby="amenity-booking"
              classes={{
                paper: 'form-dialog',
              }}
              disableBackdropClick
            >
              <DialogTitle id="amenity-booking">
                <h3
                  style={{ textAlign: 'center', margin: 0 }}
                >{`${amenity.name} ${this.props.translate('todo.booking').props.children}`}</h3>
              </DialogTitle>
              <DialogContent>
                <AmenityBookingForm
                  cancelAmenityBooking={this.cancelAmenityBooking}
                  amenity={amenity}
                  submitForm={this.submitForm}
                  toggleBookingDialog={this.props.toggleBookingDialog}
                  fullScreen={this.props.fullScreen}
                  onComplete={this.props.onComplete}
                />
              </DialogContent>
              <DialogActions style={{ display: 'block' }}>
                <FlatButton
                  primary={true}
                  style={{ color: AccentColor() }}
                  onClick={this.props.toggleBookingDialog}
                >
                  {this.props.translate('close')}
                </FlatButton>
              </DialogActions>
            </Dialog>
          );
        }
      }
    )
  )
);
